/* ============================================================
   BULIER — IL CARRELLO IN VETRO
   Si apre DA SOLO dopo ogni aggiunta al carrello riuscita: scheda
   prodotto, selettore rapido della taglia, look. Non tocca il codice
   che aggiunge (bulier.js): ascolta le chiamate a /cart/add, e quando
   una va a buon fine apre il pannello. Cosi' vale anche per i pulsanti
   che arriveranno, senza ricordarsi di collegarli.

   Il contenuto lo disegna Shopify (sezione bulier-mini-carrello): qui
   si chiede, si mostra e si gestiscono quantita' e chiusura.
   ============================================================ */
(function(){
  const SEZIONE = 'bulier-mini-carrello';
  const originale = window.fetch.bind(window);
  let pannello = null, velo = null, ultimo = null, aperto = false;

  function crea(){
    if(pannello) return;
    velo = document.createElement('div');
    velo.className = 'mc-velo';
    pannello = document.createElement('aside');
    pannello.className = 'mc-pannello';
    pannello.setAttribute('role', 'dialog');
    pannello.setAttribute('aria-modal', 'true');
    pannello.setAttribute('aria-labelledby', 'mcTitolo');
    pannello.setAttribute('tabindex', '-1');
    pannello.setAttribute('inert', '');
    document.body.append(velo, pannello);

    velo.addEventListener('click', chiudi);
    pannello.addEventListener('click', async e => {
      if(e.target.closest('[data-mc-chiudi]')){ chiudi(); return; }
      const b = e.target.closest('[data-mc-qta]');
      if(!b) return;
      const riga = b.closest('[data-mc-chiave]');
      const chiave = riga.dataset.mcChiave;
      riga.classList.add('mc__riga--attesa');
      let avviso = '';
      try{
        const r = await originale('/cart/change.js', {
          method:'POST',
          headers:{'Content-Type':'application/json','Accept':'application/json'},
          body: JSON.stringify({ id: chiave, quantity: Number(b.dataset.mcQta) })
        });
        /* di solito e' la disponibilita': "Solo 1 articolo..." lo dice
           Shopify, e va detto alla cliente invece di non fare niente */
        if(!r.ok){
          const e = await r.json().catch(() => null);
          avviso = (e && (e.description || e.message)) || 'Non sono riuscito a cambiare la quantità.';
        }
      }catch(err){ avviso = 'Non sono riuscito a cambiare la quantità.'; }
      await carica();
      if(avviso){
        const nuova = pannello.querySelector('[data-mc-chiave="' + chiave + '"] .mc__info');
        if(nuova){
          const p = document.createElement('p');
          p.className = 'mc__avviso';
          p.setAttribute('role', 'status');
          p.textContent = avviso;
          nuova.append(p);
        }
      }
      if(window.bulierAggiornaCarrello) window.bulierAggiornaCarrello();
    });
    addEventListener('keydown', e => { if(e.key === 'Escape' && aperto) chiudi(); });
  }

  function mostra(html){
    const t = document.createElement('div');
    t.innerHTML = html;
    const dentro = t.querySelector('.mc');
    if(dentro){ pannello.innerHTML = ''; pannello.append(dentro); return true; }
    return false;
  }

  async function carica(){
    try{
      const r = await originale('/?section_id=' + SEZIONE);
      const html = await r.text();
      const t = document.createElement('div');
      t.innerHTML = html;
      const dentro = t.querySelector('.mc');
      if(dentro){ pannello.innerHTML = ''; pannello.append(dentro); }
    }catch(err){
      pannello.innerHTML = '<div class="mc"><p class="mc__vuoto">Non riesco a mostrare il carrello. <a href="/cart">Aprilo qui</a>.</p></div>';
    }
  }

  /* VELOCITA': il pannello si apre SUBITO. Il contenuto arriva gia'
     dentro la risposta dell'aggiunta (Shopify lo manda se glielo si
     chiede con "sections"), quindi niente seconda richiesta. Solo se
     manca si chiede, e intanto il pannello e' gia' aperto. */
  async function apri(html){
    crea();
    ultimo = document.activeElement;
    const pronto = html && mostra(html);
    if(!pronto && !pannello.querySelector('.mc')){
      pannello.innerHTML = '<div class="mc"><div class="mc__testa"><h2 id="mcTitolo">Il tuo carrello</h2></div><p class="mc__vuoto">Un momento&hellip;</p></div>';
    }
    pannello.removeAttribute('inert');
    pannello.classList.add('aperto');
    velo.classList.add('aperto');
    document.documentElement.classList.add('mc-aperto');
    aperto = true;
    pannello.focus();
    if(!pronto) await carica();
  }

  function chiudi(){
    if(!aperto) return;
    pannello.classList.remove('aperto');
    velo.classList.remove('aperto');
    pannello.setAttribute('inert', '');
    document.documentElement.classList.remove('mc-aperto');
    aperto = false;
    if(ultimo && ultimo.focus) ultimo.focus();
  }

  window.bulierApriCarrello = apri;

  /* l'ascolto delle aggiunte: si passa la chiamata a fetch cosi' com'e',
     e solo dopo si guarda se era un'aggiunta riuscita */
  window.fetch = async function(input, init){
    const url = typeof input === 'string' ? input : (input && input.url) || '';
    const metodo = ((init && init.method) || (input && input.method) || 'GET').toUpperCase();
    /* nella pagina del carrello no: il carrello e' gia' li' davanti */
    const nelCarrello = /^\/cart\/?$/.test(location.pathname);
    const aggiunta = !nelCarrello && metodo === 'POST' && /\/cart\/add(\.js)?(\?|$)/.test(url);

    /* alla richiesta di aggiunta si chiede anche il pannello gia' disegnato */
    if(aggiunta && init && typeof init.body === 'string'){
      try{
        const corpo = JSON.parse(init.body);
        corpo.sections = SEZIONE;
        init = Object.assign({}, init, { body: JSON.stringify(corpo) });
      }catch(err){}
    }

    const risposta = await originale(input, init);
    if(aggiunta && risposta.ok){
      try{
        const dati = await risposta.clone().json();
        apri(dati && dati.sections ? dati.sections[SEZIONE] : null);
      }catch(err){ apri(); }
    }
    return risposta;
  };
})();
